import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4365a546&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4365a546&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4365a546",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4365a546')) {
      api.createRecord('4365a546', component.options)
    } else {
      api.reload('4365a546', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4365a546&scoped=true", function () {
      api.rerender('4365a546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basicSettings/companyInfo/index.vue"
export default component.exports